module.exports = __webpack_public_path__ + "img/RR.5447ba6c.png";